module.exports = __webpack_public_path__ + "media/images/home-page/3-1-ff1d6635fe84325ba47edb10fca53892.png";